import type { Key } from 'react';
import { z } from 'zod';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { NotNullStringSchema } from '@/std/schema';

export const TelefoneSchema = z.object({
    tel_descricao: NotNullStringSchema,
    tel_empresa_idpk: z.number(),
    tel_idpk: z.number(),
    tel_pessoa_idpk: z.number(),
    tel_principal: z.union([z.literal(0), z.literal(1)]),
    tel_telefone: z.string(),
    tel_ultima_alteracao: z.string().nullable(),
});

export type Telefone = z.infer<typeof TelefoneSchema>;

export type TelefoneBody = PartialUndefinedOrNull<Telefone> & {
    key: Key;
    excluir?: 'S';
};
